import OfferSlider from './HomeSections/OfferSlider';
import CategorySection from './HomeSections/CategorySections';
import './Home.css';

function Home() {
  return (
    <div className='home-container'>
      <div className='offer-slider'>
        <OfferSlider/>
      </div>
      <div>
        <CategorySection/>
      </div>
    </div>
  )
}

export default Home